<template>
  <div class="pb-5 my-team-parent">
    <div class="card-filter-section mb-50 mt-0 d-flex align-items-center justify-content-between">
      <p class="task-timesheet m-0">Proposal</p>

      <Help v-show="$store.state.app.userManualList" code="ProposalList" />
    </div>
    <!-- Filter start -->
    <div class="pr-filter">
      <div class="d-flex">
        <p class="filter-title" style="align-self: center">Filters:</p>
        <option-drop-down v-model="perPage" />
        <div class="">
          <custom-dropdown v-model="status" :options="proposalStatusList" label="Status" icon="EditIcon" multiple />
        </div>
        <div v-if="userInfo && userInfo.role == 'SA'">
          <custom-dropdown v-model="owner_ids" :options="mappedBdeList" label="Owner" icon="EditIcon"
            option-label="full_name" option-value="id" multiple />
        </div>
        <div>
          <custom-dropdown v-model="assignee_ids" :options="mappedManagerList" label="Assignee" icon="EditIcon"
            option-label="full_name" option-value="id" multiple />
        </div>
      </div>

      <div class="d-flex justify-content-center align-item-center gap-12">
        <b-input-group class="input-group-merge" style="min-width: 250px; max-width: 200px; width: 250px; height: 33px">
          <b-form-input v-model="debouncedSearch" placeholder="search by title" style="height: 33px" />

          <b-input-group-append is-text>
            <feather-icon v-if="debouncedSearch" icon="XIcon" @click="((debouncedSearch = null), (search = null))" />
            <feather-icon icon="SearchIcon" />
          </b-input-group-append>
        </b-input-group>
        <b-button
          v-if="userInfo && userInfo.role === 'SA'"
          class="btn-role btn-secondary p-75 pr-add-request"
          variant="primary"
          style="height: 33px"
          @click="toggleArchived"
        >
          {{ showArchived ? 'Show Active' : 'Show Archived' }}
        </b-button>

        <!-- <button class="apply-filter filterRedesign" @click="proposalData()" style="height: 33px">
        Apply Filter
        </button> -->
        <button class="apply-filter filterRedesign" @click="applyFilters" :disabled="isFilterLoading"
          style="height: 33px">
          {{ isFilterLoading ? "Saving..." : "Apply & Save Filters" }}
        </button>
        <button class="apply-filter-clear filterRedesign" @click="clearFilter()" style="height: 33px">
          Clear
        </button>

        <b-button v-if="canAddProposal" v-b-modal.add-proposal-modal class="btn-role btn-secondary p-75 pr-add-request"
          variant="primary" style="height: 33px">
          Add Proposal
        </b-button>
      </div>
    </div>
    <!-- Filter End -->

    <!-- member table start      -->
    <div class="myteamTbl mb-1">
      <table-loader v-if="loading" :fields="fields" />

      <b-table v-else :items="items" :fields="visibleFields" :no-border-collapse="noCollapse"
        @row-clicked="(row) => proposalDetails(row.id)" responsive hover>
        <template #cell(project_name)="data">
          <div class="d-flex align-items-center">
            <p
              class="mb-0"
              v-b-tooltip.hover.bottom
              :title="data.item.project_title || '-'"
            >
              {{ data.item.project_title || '-' }}
            </p>
          </div>
        </template>
        <template #cell(client_name)="data">
          <p v-b-tooltip.hover.bottom="data.item.client_company_name
            ? data.item.client_company_name
            : '-'
            ">
            {{
              data.item.client_company_name
                ? data.item.client_company_name
                : "-"
            }}
          </p>
        </template>
        <template #cell(crm_lead_link)="data">
          <a v-if="data.item.crm_lead_link" :href="data.item.crm_lead_link" target="_blank"
            class="detail-value text-primary">
            View Lead
            <feather-icon icon="ExternalLinkIcon" size="14" />
          </a>
          <span v-else>-</span>
        </template>
        <template #cell(description)="data">
          <p v-b-tooltip.hover.bottom="data.item.description ? data.item.description : ''
            " class="long-text">
            {{ data.item.description }}
          </p>
        </template>
        <template #cell(project_type)="data">
          <p v-b-tooltip.hover.bottom="data.item.proposal_type ? data.item.proposal_type : ''
            " class="long-text">
            {{ data.item.proposal_type }}
          </p>
        </template>
        <template #cell(score)="data">
          <p v-b-tooltip.hover.bottom="data.item.lead_qualification_score
            ? data.item.lead_qualification_score
            : ''
            " class="long-text">
            {{ data.item.lead_qualification_score }}
          </p>
        </template>
        <template #cell(tech_stack)="data">
          <p v-b-tooltip.hover.bottom="data.item.expected_tech_stack ? data.item.expected_tech_stack : ''
            " class="long-text">
            {{ data.item.expected_tech_stack }}
          </p>
        </template>
        <template #cell(size)="data">
          <p v-b-tooltip.hover.bottom="data.item.project_size ? data.item.project_size : ''
            " class="long-text">
            {{ data.item.project_size }}
          </p>
        </template>
        <template #cell(status)="data">
          {{ data.item.status ? getStatusText(data.item.status) : "-" }}
        </template>
        <template #cell(owner)="data">
          {{
            data.item.created_by && data.item.owner.full_name
              ? data.item.owner.full_name
              : "-"
          }}
        </template>
        <template #cell(assigned_to)="data">
          <div class="assignee-container d-flex align-items-center">
            <template v-if="
              data.item.proposal_assignees &&
              data.item.proposal_assignees.length
            ">
              <!-- First two assignees -->
              <div class="d-flex align-items-center">
                <div v-for="assignee in data.item.proposal_assignees.slice(0, 2)" :key="assignee.id"
                  class="assignee-avatar-container d-flex align-items-center" v-b-tooltip.hover :title="assignee.user && assignee.user.full_name
                    ? assignee.user.full_name
                    : 'N/A'
                    ">
                  <!-- Avatar with image -->
                  <b-avatar v-if="assignee.user && assignee.user.picture" :src="assignee.user.picture" size="30"
                    class="assignee-avatar" />

                  <!-- Avatar with TEXT (same as new-time-report) -->
                  <b-avatar v-else size="30" :text="((assignee.user && assignee.user.full_name) || '').split(
                    ' '
                  )[0] | avatarText
                    " style="background-color: #f97753" class="assignee-avatar" />
                </div>
              </div>

              <!-- +X more badge -->
              <b-badge v-if="data.item.proposal_assignees.length > 2" v-b-tooltip.hover
                :title="getRemainingAssignees(data.item.proposal_assignees)" variant="light-primary"
                class="cursor-pointer ml-1">
                +{{ data.item.proposal_assignees.length - 2 }}
              </b-badge>
            </template>

            <span v-else>-</span>
          </div>
        </template>

        <template #cell(emptblLast)="data">
          <div
            v-if="!showArchived"
            class="d-flex align-items-center"
            @click.stop
          >
            <template v-if="data.item.id && canEditOrDeleteProposal(data.item)">
              <div
                data-tooltip-id="Delete"
                data-tooltip-content="Delete"
                class="cursor-pointer mr-2"
                @click="deleteConfirmation(data.item)"
              >
                <feather-icon icon="Trash2Icon" class="edit-icon" size="20" />
              </div>

              <div
                data-tooltip-id="Edit"
                data-tooltip-content="Edit"
                class="cursor-pointer"
                @click="editProposal(data.item)"
              >
                <feather-icon icon="EditIcon" class="edit-icon" size="20" />
              </div>
            </template>
          </div>
          <div v-else>
            -
          </div>
        </template>
      </b-table>

      <!-- pagination section -->
      <Pagination v-if="totalCount > 0 && !loading" :current-page="currentPage"
        :per-page="perPage" :total-count="totalCount" @currentPage="currentPage = $event" />
      <!-- pagination section complete here -->

      <!-- Add/Edit Proposal Modal -->
      <div>
        <div class="addtask">
          <b-modal id="add-proposal-modal" cancel-variant="outline-secondary" centered size="lg"
            modal-class="proposal-modal" scrollable @hidden="resetModal">
            <!-- Modal Title (UNCHANGED) -->
            <template #modal-title>
              <h3 class="sprint-from-title sprint-bottom ml-0 mb-1 pb-50">
                {{
                  proposal_id
                    ? "Edit Proposal"
                    : userInfo && userInfo.role == "SA"
                      ? "Add Proposal"
                      : "Request New Proposal"
                }}
              </h3>
            </template>

            <!-- MOVE observer INSIDE modal -->
            <validation-observer ref="proposalObserver">
              <b-row class="addtask-content">
                <!-- Project Title -->
                <b-col cols="12">
                  <b-form-group>
                    <label for="project-title" class="form-label">
                      Project Title <span class="text-danger">*</span>
                    </label>
                    <validation-provider name="Project Title" rules="required|max:255" #default="{ errors }">
                      <b-form-input id="project-title" v-model.trim="project_title" placeholder="Project Title" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- Client Company Name -->
                <b-col cols="12">
                  <b-form-group>
                    <label for="client-company" class="form-label">
                      Client Company Name <span class="text-danger">*</span>
                    </label>
                    <validation-provider name="Client Company Name" rules="required|max:255" #default="{ errors }">
                      <b-form-input id="client-company" v-model.trim="client_company_name"
                        placeholder="Client Company Name" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- Description -->
                <b-col cols="12">
                  <b-form-group>
                    <label for="description" class="form-label">
                      Description <span class="text-danger">*</span>
                    </label>
                    <validation-provider name="Description" rules="required|max:2024" #default="{ errors }">
                      <b-form-textarea id="description" v-model.trim="description" rows="3"
                        placeholder="Enter description" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- CRM Lead Link -->
                <b-col cols="12">
                  <b-form-group>
                    <label for="crm_lead_link" class="form-label">
                      CRM Lead Link <span class="text-danger">*</span>
                    </label>
                    <validation-provider name="CRM Lead Link" rules="required|max:512" #default="{ errors }">
                      <b-form-input id="crm_lead_link" v-model.trim="crm_lead_link" placeholder="CRM Lead Link"
                        name="CRM Lead Link" @input="validateCrmLeadLink" />
                      <small class="text-danger" v-if="
                        errors[0] &&
                        errors[0] !==
                        'The CRM Lead Link field must be a valid URL'
                      ">
                        {{ errors[0] }}
                      </small>
                      <small class="text-danger" v-if="crmLinkError">
                        {{ crmLinkError }}
                      </small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- Lead Qualification Score -->
                <b-col cols="12">
                  <b-form-group>
                    <label for="lead_qualification_score" class="form-label">
                      Lead Qualification Score <span class="text-danger">*</span>
                    </label>
                    <validation-provider name="Lead Qualification Score" rules="required|max:512" #default="{ errors }">
                      <b-form-input id="lead_qualification_score" v-model.trim="lead_qualification_score"
                        placeholder="Lead Qualification Score" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- Expected Tech Stack -->
                <b-col cols="12">
                  <b-form-group>
                    <label for="expected_tech_stack" class="form-label">
                      Expected Tech Stack <span class="text-danger">*</span>
                    </label>
                    <validation-provider name="Expected Tech Stack" rules="required|max:512" #default="{ errors }">
                      <b-form-input id="expected_tech_stack" v-model.trim="expected_tech_stack"
                        placeholder="Expected Tech Stack" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- Project Size -->
                <b-col cols="12">
                  <b-form-group>
                    <label for="project_size" class="form-label">
                      Project Size <span class="text-danger">*</span>
                    </label>
                    <validation-provider name="Project Size" rules="required|max:512" #default="{ errors }">
                      <b-form-input id="project_size" v-model.trim="project_size" placeholder="Project Size" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- Proposal Type -->
                <b-col cols="12">
                  <b-form-group>
                    <label for="proposal_type" class="form-label">
                      Proposal Type <span class="text-danger">*</span>
                    </label>
                    <validation-provider name="Proposal Type" rules="required|max:512" #default="{ errors }">
                      <b-form-textarea id="proposal_type" v-model.trim="proposal_type" rows="3"
                        placeholder="Enter Proposal Type" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <!-- Proposal Owners -->
                <b-col cols="12" v-if="userInfo && userInfo.role == 'SA'">
                  <div class="form-group mb-4">
                    <label class="form-label">Owner</label>
                    <b-form-select v-model="selectedOwner" :options="mappedBdeList" option-value="value" option-text="label"/>
                  </div>
                </b-col>

                <!-- Proposal Assignees -->
                <b-col cols="12">
                  <b-form-group v-if="userInfo && userInfo.role == 'SA'">
                    <label for="assignees">Assignees</label>
                    <validation-provider #default="{ errors }" name="Assignees">
                      <v-select id="assignees" v-model="selectedAssignee" hide-details multiple name="assignees" label="label"
                        :options="mappedManagerList" :reduce="(user) => user.value" class="select-tags-timesheet3"
                        placeholder="Select Any Assignees"
                        :close-on-select="false" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                
                <!-- Attachments -->
                <b-col cols="12">
                  <b-form-group label="Attachments" label-for="attachments">
                    <file-upload ref="fileUpload" :manual-file-added="attachments" @onChange="handleFileUpload"
                      @onFileRemove="remove_attachments = $event" />
                  </b-form-group>
                </b-col>
              </b-row>
            </validation-observer>

            <!-- Footer (UNCHANGED POSITION & STYLE) -->
            <template #modal-footer>
              <b-button variant="outline-secondary" :disabled="isSaving" @click="closeModal">
                Cancel
              </b-button>
              <b-button
                variant="primary"
                type="button"
                :disabled="isSaving || !isFormValid"
                @click="validationForm"
              >
                <b-spinner v-if="isSaving" small class="mr-1" />
                {{ isEditing ? "Update" : "Create" }}
              </b-button>
            </template>
          </b-modal>
        </div>
      </div>
      <!-- Add/Edit Proposal Modal End -->
    </div>
    <!-- member table end  -->

    <!-- data table complete -->
    <img v-if="!loading && totalCount == 0" src="@/assets/images/nodatafound/nodata.svg" alt="no-data"
      class="no-data-img" />
  </div>
</template>

<script>
import proposalMixin from "@/mixin/proposal/proposalMixin.js";

export default {
  name: "Proposal",
  mixins: [proposalMixin],
};
</script>

<style lang="scss" scoped>
@import "./../../assets/scss/component-css/masterSettingFilter.scss";
@import "./../../assets/scss/component-css/tesing.css";
@import "./../../assets/scss/component-css/prrequest.scss";
@import "./../../assets/scss/component-css/list.css";
@import "./../../assets/scss/component-css/addProjectFeedback.css";

.myteamTbl .table tbody td p.resume_description {
  width: 300px !important;
  overflow-wrap: break-word;
  white-space: break-spaces;
}

.addtask-modal .modal-content {
  max-height: 90vh !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

.addtask-content {
  padding-bottom: 0;
}

.addtask-modal .modal-dialog {
  max-width: 90vw !important;
}

.addtask-modal .modal-dialog-scrollable .modal-body {
  overflow-y: unset !important;
}

.long-text {
  max-width: 200px !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
</style>
